module.exports = __webpack_public_path__ + "static/img/2b.f557d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2b.png
// module id = 1GF4
// module chunks = 1